export default __webpack_public_path__ + "static/fixedMenuWechatIcon-44d10f737a8019f5d413bd60e1aa0bc3.svg";